import { gsap, PixiPlugin, MotionPathPlugin } from "gsap/all";

import * as PIXI from 'pixi.js-legacy';
import "pixi-spine";
import "pixi-particles";

import * as P3 from "p3";

gsap.install(global);

gsap.registerPlugin(PixiPlugin);
gsap.registerPlugin(MotionPathPlugin);

gsap.defaults({ overwrite: false });

import Main from "./Main";

const startApp = () => {
    const entry = new Main(1024, 768);
    entry.init();

    console.log('StatusBar');
    console.log(window.StatusBar);
    if (window.StatusBar) {
        StatusBar.hide();
        console.log('HIDING STATUS BAR');
    }
}

if (typeof cordova === "undefined") {
    startApp();
} else {
    document.addEventListener("deviceready", startApp, false);
}

